export default "__VITE_ASSET__DasGz7Ik__"